import ModalNew, { DialogType, Result } from 'bz-core-controls/modal-new/confirmation/stores';
import { Provider, inject, observer } from 'mobx-react';
import { action, computed, observable, toJS } from 'mobx';

import ClinicalEndpoints from 'bz-pronto-core/endpoints/clinical';
import JsonServiceClient from 'bz-stores/lib/JsonServiceClient';
import LazyWrapper from 'bz-core-controls/controls/lazy';

//import ProntoReportWizard from '../../../../../../app/modules/my-clinic/controls/referral/controls/editor/controls/report/controls/wizard';
import React, { lazy } from 'react';
const ProntoReportWizard = LazyWrapper(
  lazy(
    () =>
      import('modules/my-clinic/controls/referral/controls/editor/controls/report/controls/wizard')
  )
);
import Report from 'bz-core-controls/controls/general/report';
import ReportStore from 'bz-core-controls/controls/general/report/stores/report-store';
import { SubmitReportRequest } from 'tm3-core/api.dtos';
import moment from 'moment';

import { Button } from '@material-ui/core';

@inject('clinicalStore')
@observer
class ReportEditor extends React.Component {
  client = new JsonServiceClient('/api');
  @observable data = new Map();
  @observable showProntoReportWizard = false;
  @observable appointmentsToLock = [];

  constructor(props) {
    super(props);
    let { data, template, reportTemplateType } = this.report.draft;

    this.draft = new ReportStore();
    this.draft.mode = 'form';
    this.draft.data = data || {};
    this.draft.template = template;
    this.draft.reportTemplateType = reportTemplateType;
    this.data.replace(toJS(data));

    const { referralStore } = this.props.clinicalStore.caseStore;

    if (!!referralStore.referral.linkAppointmentsToReports) {
      const { appointments = [] } = referralStore.referral;
      const { disableInvoicingAppointmentsInThePast } = referralStore.referral;

      let filteredApps = appointments.filter((a) => !a.isLocked);

      if (disableInvoicingAppointmentsInThePast) {
        filteredApps = filteredApps.filter((a) => {
          const startDateTime = moment(a.date);
          return startDateTime.isBefore();
        });
      }

      this.appointmentsToLock.replace(filteredApps.map((a) => a.id));
    }
  }

  @computed
  get shouldLinkAppointmentsToReports() {
    const { referralStore } = this.props.clinicalStore.caseStore;

    if (!!referralStore.referral) {
      return referralStore.referral.linkAppointmentsToReports;
    }
    return false;
  }

  @action.bound
  onChange(data) {
    this.data.replace(data);
  }

  render() {
    let { store } = this.props;
    if (!store) return null;

    const date = new moment(store.details.dateTime);
    const subtitle = `${date.format('dddd Do MMMM YYYY')} at ${date.format('h:mma')}`;
    const { referralStore } = this.props.clinicalStore.caseStore;

    const prontoReportButtons = this.showProntoReportWizard ? (
      <Button variant="outlined" onClick={this.onSubmitProntoApptsToLock}>
        Submit
      </Button>
    ) : (
      <Button variant="outlined" onClick={this.onShowProntoReportWizard}>
        Next
      </Button>
    );

    return (
      <div className="clinical-overlay clinical-overlay-edit">
        <div className="clinical-editor-panel">
          <div className="clinical-editor-header">
            <div className="title">
              <h1>Report</h1>
              <h4>{subtitle}</h4>
            </div>
            <div className="actions">
              {this.showProntoReportWizard ? (
                <Button variant="outlined" onClick={this.onShowProntoReportWizard}>
                  Back
                </Button>
              ) : (
                <Button variant="outlined" onClick={this.onSave}>
                  Save Draft
                </Button>
              )}
              {this.shouldLinkAppointmentsToReports ? (
                prontoReportButtons
              ) : (
                <Button variant="outlined" onClick={this.onSubmit}>
                  Submit
                </Button>
              )}
              <Button variant="outlined" onClick={this.onRequestClose}>
                Cancel
              </Button>
            </div>
          </div>
          <div className="clinical-editor-body">
            <Provider referralStore={referralStore}>
              {this.showProntoReportWizard ? (
                <ProntoReportWizard appointmentsToLock={this.appointmentsToLock} />
              ) : (
                <Report store={this.draft} onStateChange={this.onChange} />
              )}
            </Provider>
          </div>
        </div>
      </div>
    );
  }

  @computed
  get report() {
    let { store, clinicalStore } = this.props;
    let { reports } = clinicalStore.prontoStore;
    let { details } = store;
    let id = (details.get('data') || {}).id;
    return reports.get(id || 0);
  }

  @action.bound
  onShowProntoReportWizard() {
    const data = toJS(this.data);
    this.draft.data = data;
    this.draft
      .applyValidation()
      .then((isValid) => {
        this.showProntoReportWizard = !this.showProntoReportWizard;
      })
      .catch((error) => {
        return;
      });
  }

  @action.bound
  onUpdate() {
    let { caseId } = toJS(this.props.store.details);

    let data = toJS(this.data);
    this.report.draft.data = data;
    let request = toJS(this.report);

    request.data = JSON.stringify(data);
    request.caseId = caseId;

    return request;
  }

  @action.bound
  onSave() {
    let request = this.onUpdate();

    ClinicalEndpoints.onUpdate(request).then((res) => {
      if (!!res) {
        this.props.onRequestClose();
      }
    });
  }

  @action.bound
  onSubmit() {
    let request = this.onUpdate();
    this.draft
      .applyValidation()
      .then((isValid) => {
        ClinicalEndpoints.onSubmit(request).then((res) => {
          if (!res) return;
          this.report.status = res.status;
          this.props.onRequestClose();
        });
      })
      .catch((error) => {
        ModalNew.open(DialogType.alert, {
          title: 'Validation Errors',
          contents: 'Please complete all the required fields in order to submit this report. ',
          okLabel: 'OK'
        });

        return;
      });
  }

  @action.bound
  async onSubmitProntoApptsToLock() {
    const { referral } = this.props.clinicalStore.caseStore.referralStore;
    const { id } = referral.audit;

    if (referral.linkAppointmentsToReports) {
      if (this.appointmentsToLock.length === 0) {
        return;
      }

      const result = await ModalNew.open(DialogType.yesno, {
        title: 'Are you sure you want to submit this report?',
        contents:
          'All selected appointments will be locked. This is a permanent action and cannot be undone. '
      });

      if (result !== Result.yes) {
        return;
      }
    }

    const reqData = {
      auditId: id,
      appointmentsToLock: this.appointmentsToLock,
      linkInvoicesToReports: referral.linkInvoicesToReports,
      bookingAuditResponse: referral.audit
    };

    const res = await this.client.post(new SubmitReportRequest(reqData));

    const { appointments, invoice } = res.result;

    referral.appointments = appointments;
    this.appointmentsToLock.replace(appointments.filter((a) => !a.isLocked).map((a) => a.id));
    if (invoice != null) {
      referral.invoices.push(invoice);
    }
    this.onSubmit();
  }

  @action.bound
  onRequestClose() {
    this.props.onRequestClose();
  }
}

export default ReportEditor;
